{
	"noData": {
		"title": "We couldn't find what you're looking for",
		"description": "Try selecting a new location or period, or try again later."
	},
	"noFilters": {
		"title": "There's nothing here yet",
		"description": "Select the search location or check again later."
	},
	"noContent": {
		"title": "There is nothing here yet",
		"description": "Select a period to start exploring the data."
	}
}
